import { Identifiable, Planzone, WbsConfiguration } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getDefaultConf(): WbsConfiguration {
  return [
    {
      name: "Default",
      roles: [
        "pz_admin",
        "pz_under_admin",
        "pz_user",
        "pz_visitor",
        "pr_visitor",
        "pr_manager",
        "pr_worker",
      ],
      columns: [
        { key: "statuses" },
        { key: "tags" },
        { key: "allocations" },
        { key: "endDate" },
        { key: "completionDate" },
      ],
    },
  ];
}

function getWbsConfiguration(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ data }) =>
        !!data.wbsViewConfigurations
          ? JSON.parse(data.wbsViewConfigurations)
          : getDefaultConf(),
      );
}

export { getWbsConfiguration };
